export default {
  INIT_LION: "INIT_LION",

  LION_CONFIG: "LION_CONFIG",
  LION_SET_LANGUAGE: "LION_SET_LANGUAGE",
  LION_SET_FALLBACK_LANGUAGE: "LION_SET_FALLBACK_LANGUAGE",
  LION_SET_RESOURCES_APP: "LION_SET_RESOURCES_APP",
  LION_SET_RESOURCES_APP_LOADED: "LION_SET_RESOURCES_APP_LOADED",
  LION_SET_RESOURCES_PRODUCT: "LION_SET_RESOURCES_PRODUCT",
  LION_SET_RESOURCES_PRODUCT_LOADED: "LION_SET_RESOURCES_PRODUCT_LOADED"
};